import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import 'react-phone-number-input/style.css'
import { styled } from '@mui/material/styles';
import {  Typography,  Avatar, } from '@mui/material';
import Assessmentapi from '../landing_website/assets/images/AssessmentAPI.jpeg'
 import FooterLandingPage from '../_layout/elements/landing-footer';
import HeaderLandingPage from '../_layout/elements/landing-header';
import { changeAuth } from '../actions/loginAction';
import { useDispatch } from 'react-redux';
import host from '../host';
import Editor from "@draft-js-plugins/editor";
import { EditorState, convertFromRaw, ContentState } from "draft-js";
import createImagePlugin from "@draft-js-plugins/image";
import createResizeablePlugin from "@draft-js-plugins/resizeable";

export const ArticleDetail = () => { 

const { id } = useParams();
const dispatch = useDispatch();
const navigate = useNavigate();

const imagePlugin = createImagePlugin();
const resizeablePlugin = createResizeablePlugin();

const plugins = [imagePlugin, resizeablePlugin];

const [severity, setSeverity] = useState("");
const [message, setMessage] = useState("");
const [snackbar, setSnackbar] = useState(false);
const onClose = () => {
      setSnackbar(false);
    };
const [article, setArticle] = useState({});
const [editorState, setEditorState] = useState(EditorState.createEmpty());
const getArticle = () => {
   fetch(host.chaturl + `/admin/article/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
         else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/");
        }
         else {
          // setPageLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if(data.article){
         setArticle(data.article);

         let articleContent = "";
      try {
        let temp = JSON.parse(data.article.content);
        let contentState = convertFromRaw(temp);
        articleContent = EditorState.createWithContent(contentState);
      } catch (error) {
        console.error("Error parsing question data:", error);
        // If an error occurs, create an EditorState with the text "NA" or "Not Available".
        const contentStateNA = ContentState.createFromText("NA");
        articleContent = EditorState.createWithContent(contentStateNA);
      }
      setEditorState(articleContent);
        }
        
      })
      .catch((err) => {
        console.log(err);
        // setPageLoaded(true);
      });
}

function formatDate(inputDate) {
   // Parse the input date string to a Date object
   if(inputDate){
      const date = new Date(inputDate);
   // Define options for formatting the date
   const options = { year: 'numeric', month: 'long', day: 'numeric' };
 
   // Use Intl.DateTimeFormat to format the date
   const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
 
   return formattedDate;
   }
   else{
      return "NA";
   }
 }

useEffect(() => {
   if(id){
      getArticle();
   }
},[id])

return (
<div>
   <div className='inner-header'>
      <HeaderLandingPage />
   </div>
  
   <section className="padding_medium">
      <div className="container"  >
         <div className="row justify-content-center">
            <div className="col-md-8">
            <div className='blog-wrapper'>
     
                     <div className='blog-content'>
                        <section className='blog-section blog_section_pedding pb-0' id=" ">
                           <div className='blog-type'>
                              <div className='video-creator'>
                                 <div className='creator-left'>
                                    <Avatar className='creator-avtar'>{article?.user_info?.fullname?.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '')}</Avatar>
                                    <div className='artical_info_flex' >
                                       <Typography variant="body2"  >
                                          {article?.user_info?.fullname ? article?.user_info?.fullname : "NA"}
                                       </Typography>
                                       <div className='articalpost'>
                                          <span className='update-date'>{formatDate(article.created_at)}</span>
                                          {/* <span className='badge bg-inverse-success '> Public</span> */}
                                       </div>
                                    </div>
                                 </div>
                             
                              </div>
                           </div>
                           <h1 className='mb-0'> {article.title ? article.title : "NA"}</h1>
                           <div className='detail_cover_image'>
                              <img src={article.image ? article.image : Assessmentapi} alt='' className=' ' />
                           </div>
                        </section>
                        <section className='blog-section blog_section_pedding' id="Interduction">
                        <Editor
                                      editorState={editorState}
                                      customStyleMap={{
                                        SUBSCRIPT: {
                                          fontSize: "0.6em",
                                          verticalAlign: "sub",
                                        },
                                        SUPERSCRIPT: {
                                          fontSize: "0.6em",
                                          verticalAlign: "super",
                                        },
                                      }}
                                      plugins={plugins}
                                      readOnly={true}
                                    />
                        </section>
                     </div>
             
            </div>
            </div>
         </div>
      </div>
   </section>
  
   <FooterLandingPage />
</div>
)
}